import { useState, useEffect } from 'react';
import { Modal, Button } from '@components/ui';
import { toast } from 'react-toastify';
import { personnelRoles } from '@mocks/personel';

export default function PersonnelModal({ isOpen, onClose, onSubmit, personnel = null }) {
    const isEditMode = !!personnel;

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        role: 'worker',
        dailyWage: '',
        startDate: new Date().toISOString().split('T')[0],
        tcNo: '',
        address: '',
        emergencyContact: '',
    });

    useEffect(() => {
        if (personnel) {
            setFormData({
                name: personnel.name || '',
                phone: personnel.phone || '',
                role: personnel.role || 'worker',
                dailyWage: personnel.dailyWage?.toString() || '',
                startDate: personnel.startDate || new Date().toISOString().split('T')[0],
                tcNo: personnel.tcNo || '',
                address: personnel.address || '',
                emergencyContact: personnel.emergencyContact || '',
            });
        } else {
            setFormData({
                name: '',
                phone: '',
                role: 'worker',
                dailyWage: '',
                startDate: new Date().toISOString().split('T')[0],
                tcNo: '',
                address: '',
                emergencyContact: '',
            });
        }
    }, [personnel, isOpen]);

    const handleSubmit = () => {
        if (!formData.name || !formData.phone) {
            toast.error('Lütfen zorunlu alanları doldurun');
            return;
        }

        onSubmit?.({
            ...formData,
            dailyWage: parseFloat(formData.dailyWage) || 0,
        });

        toast.success(isEditMode ? 'Personel güncellendi' : 'Personel eklendi');
        onClose();
    };

    const handleChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={isEditMode ? '✏️ Personel Düzenle' : '👷 Yeni Personel Ekle'}
            size="md"
            footer={
                <>
                    <Button variant="ghost" onClick={onClose} className="min-h-[44px]">İptal</Button>
                    <Button variant="primary" onClick={handleSubmit} className="min-h-[44px]">
                        {isEditMode ? 'Güncelle' : 'Kaydet'}
                    </Button>
                </>
            }
        >
            <div className="space-y-4">
                {/* Ad Soyad */}
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Ad Soyad *</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary"
                        placeholder="Ahmet Yılmaz"
                        value={formData.name}
                        onChange={(e) => handleChange('name', e.target.value)}
                    />
                </div>

                {/* Telefon ve Rol */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Telefon *</label>
                        <input
                            type="tel"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary"
                            placeholder="0532 123 4567"
                            value={formData.phone}
                            onChange={(e) => handleChange('phone', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Rol</label>
                        <select
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary min-h-[48px]"
                            value={formData.role}
                            onChange={(e) => handleChange('role', e.target.value)}
                        >
                            {personnelRoles.map(role => (
                                <option key={role.key} value={role.key}>{role.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Günlük Ücret ve Başlangıç */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Günlük Ücret (₺)</label>
                        <input
                            type="number"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary"
                            placeholder="500"
                            value={formData.dailyWage}
                            onChange={(e) => handleChange('dailyWage', e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-text-secondary mb-1">Başlangıç Tarihi</label>
                        <input
                            type="date"
                            className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary min-h-[48px]"
                            value={formData.startDate}
                            onChange={(e) => handleChange('startDate', e.target.value)}
                        />
                    </div>
                </div>

                {/* TC No */}
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">TC Kimlik No</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary"
                        placeholder="12345678901"
                        maxLength={11}
                        value={formData.tcNo}
                        onChange={(e) => handleChange('tcNo', e.target.value)}
                    />
                </div>

                {/* Adres */}
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Adres</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary"
                        placeholder="İkamet adresi..."
                        value={formData.address}
                        onChange={(e) => handleChange('address', e.target.value)}
                    />
                </div>

                {/* Acil İletişim */}
                <div>
                    <label className="block text-sm font-medium text-text-secondary mb-1">Acil Durumda İletişim</label>
                    <input
                        type="text"
                        className="w-full px-4 py-3 rounded-lg border border-border-light bg-bg-primary text-text-primary"
                        placeholder="İsim ve telefon"
                        value={formData.emergencyContact}
                        onChange={(e) => handleChange('emergencyContact', e.target.value)}
                    />
                </div>
            </div>
        </Modal>
    );
}
